<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button @click="goToAdd()" class="bg-primary float-right" type="filled">{{$t("Labels.Add")}}</vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
          <vs-input class="w-full" :placeholder="$t('Labels.Name')" v-model="filter.name"/>
      </div>
      <div class="vx-col">
        <vs-button  @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>
      </div>
    </div>
    <vs-table v-if="response" :data="response"
      @selected="goToDetail">
      <template slot="thead">
          <vs-th sort-key="name">
            {{$t('Labels.Name')}}
          </vs-th>
          <vs-th sort-key="description">
            {{$t('Labels.Description')}}
          </vs-th>
          <vs-th sort-key="licenses">
            {{$t('Labels.Licenses')}}
          </vs-th>
          <vs-th sort-key="created_at">
            {{$t('Labels.CreatedAt')}}
          </vs-th>
      </template>

      <template  slot-scope="{data}">
        <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
          <vs-td :data="item.name">
            {{item.name}}
          </vs-td>
          <vs-td :data="item.description">
            {{item.description}}
          </vs-td>
          <vs-td :data="item.licenses">
            {{item.licenses}}
          </vs-td>
          <vs-td :data="item.created_at">
            {{item.created_at}}
          </vs-td>
        </vs-tr>
      </template>


    </vs-table>
    <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
  </div>
</template>

<script>
import {request} from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'

export default {
  components: {
    listItem
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      active:false,
      totalPages: 0,
      oldCurrentPage: 1,
      filter:{
        name:'',
        networkId:'',
        limit:10000,
        offset:0,
        byColumn:'name',
        byOrder:'asc'
      },
      selected: {}
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'applications',
        method: 'GET',
        params:this.filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.totalPages = response.data.data.count
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    goToDetail (tr) {
      window.location.href = `/apps/${tr.uuid}`
    },
    goToAdd () {
      window.location.href = '/apps/add'
    }
  },

  created () {
    /*this.$route.meta.breadcrumb[1].title = this.$t('Path.Apps')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.List')
    this.$route.meta.pageTitle = this.$t('Path.List')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})*/
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  },

  updated () {
    if (this.oldCurrentPage != this.currentx) {
      this.oldCurrentPage = this.currentx
      this.getActualizar()
    }
  }
}
</script>
